import { connect } from 'react-redux';
import React, { Component } from 'react';
import { injectStripe, PaymentRequestButtonElement, CardNumberElement, CardExpiryElement, CardCVCElement } from 'react-stripe-elements';
import { processPayment, createPaymentClientSecret, closePaymentDialogEmbeddedForm } from './../actions'
import DisplayIf from 'shared/DisplayIf.jsx';
import StandardModal from 'shared/StandardModal.jsx';
import './PaymentForm.css'

const requiredErrorMessages = {
    cardholderNameRequired: "Your card holder Name is incomplete.",
    cardNumberRequired: "Your card number is incomplete.",
    cardExpiryRequired: "Your card’s expiration date is incomplete.",
    cardCvcRequired: "Your card’s security code is incomplete."
};


class PaymentForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            paymentError: null,
            success: false,
            isLoading: false,
            paymentRequest: null,
            canMakePayment: false,
            paymentProcessing: false,
            cardElements: {
                cardholderName: { complete: false, error: requiredErrorMessages.cardholderNameRequired, touched: false },
                cardNumber: { complete: false, error: requiredErrorMessages.cardNumberRequired, touched: false },
                cardExpiry: { complete: false, error: requiredErrorMessages.cardExpiryRequired, touched: false },
                cardCvc: { complete: false, error: requiredErrorMessages.cardCvcRequired, touched: false }
            },
        };

        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handlePaymentRequestButtonClick = this.handlePaymentRequestButtonClick.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleCardElementChange = this.handleCardElementChange.bind(this);

        if (!this.props.stripe) {
            console.warn("Stripe has not loaded yet.");
            return;
        }

        const { stripe, total } = this.props;

        if (stripe) {

            const paymentRequest = stripe.paymentRequest({
                country: 'US',
                currency: 'usd',
                total: { label: 'Total Amount', amount: total * 100 },
            });

            paymentRequest.canMakePayment().then((result) => {
                console.log('canMakePayment', result);
                if (result) {
                    this.setState({ paymentRequest });
                    this.setState({ canMakePayment: !!result });
                } else {
                    console.warn("Payment Request is still not available.");
                }
            });

            paymentRequest.on('paymentmethod', (event) => {

                const { stripe, createPaymentClientSecret, registration, processPayment, cart, closePaymentDialogEmbeddedForm } = this.props;

                console.log("cart", cart);

                let thisInst = this;

                createPaymentClientSecret(cart)
                    .then((result) => {

                        const errorMessages = result.messages;

                        if (!errorMessages || errorMessages.length == 0) {

                            const clientSecret = result.paymentId;

                            if (!clientSecret) {
                                event.complete('fail');
                                return;
                            }

                            stripe.confirmPaymentIntent(clientSecret, {
                                payment_method: event.paymentMethod.id,
                            }).then(function (result) {
                                if (result.error) {
                                    thisInst.setPaymentError(result.error.message);
                                    event.complete('fail');
                                } else {
                                    const paymentDetail = {
                                        PaymentId: result.paymentIntent.id,
                                        TournamentId: registration.base.tournamentId
                                    };

                                    processPayment(paymentDetail);

                                    event.complete('success');
                                    closePaymentDialogEmbeddedForm();
                                }
                            });

                        } else {
                            event.complete('fail');
                        }
                    })
                    .catch(error => {
                        event.complete('fail');
                    });
            });
        }
    }

    handleNameChange(event) {
        const { value } = event.target;
        this.setState(prevState => ({
            cardElements: {
                ...prevState.cardElements,
                cardholderName: {
                    value: value,
                    complete: !!value,
                    error: !value ? requiredErrorMessages.cardholderNameRequired : '',
                    touched: true
                }
            },
        }));
    }

    handleCardElementChange(change) {
        this.setState(prevState => ({
            cardElements: {
                ...prevState.cardElements,
                [change.elementType]: {
                    complete: change.complete,
                    error: change.error ? change.error.message : (!change.complete ? requiredErrorMessages[change.elementType] : ''),
                    touched: true
                }
            },
        }));
    }


    handleFormSubmit(event) {
        event.preventDefault();

        this.setState(prevState => ({
            ...prevState,
            cardElements: {
                cardholderName: { ...prevState.cardElements.cardholderName, touched: true },
                cardNumber: { ...prevState.cardElements.cardNumber, touched: true },
                cardExpiry: { ...prevState.cardElements.cardExpiry, touched: true },
                cardCvc: { ...prevState.cardElements.cardCvc, touched: true }
            },
        }));

        const { createPaymentClientSecret, cart } = this.props;

        if (!!this.state.cardElements.cardholderName.error ||
            !!this.state.cardElements.cardNumber.error ||
            !!this.state.cardElements.cardExpiry.error ||
            !!this.state.cardElements.cardCvc.error) {
            return;
        }

        this.startPaymentProcessingState();

        createPaymentClientSecret(cart)
            .then((result) => {

                const errorMessages = result.messages;

                if (!errorMessages || errorMessages.length == 0) {

                    const { stripe, registration, processPayment, closePaymentDialogEmbeddedForm } = this.props;
                    const cardNumberElement = this.props.elements.getElement('cardNumber');

                    const clientSecret = result.paymentId;

                    if (!stripe || !clientSecret) {
                        this.finishPaymentProcessingState();
                        return;
                    }

                    try {
                        let thisInst = this;
                        stripe.confirmCardPayment(clientSecret, {
                            payment_method: {
                                card: cardNumberElement,
                                billing_details: {
                                    name: this.state.cardholderName, // Include cardholder name
                                },
                            },
                        }).then(function (result) {

                            thisInst.finishPaymentProcessingState();

                            if (result.error) {
                                thisInst.setPaymentError(result.error.message);
                            } else {
                                const paymentDetail = {
                                    PaymentId: result.paymentIntent.id,
                                    TournamentId: registration.base.tournamentId
                                };

                                processPayment(paymentDetail);
                                closePaymentDialogEmbeddedForm();
                            }
                        });
                    } catch (err) {
                        console.error('Unexpected error:', err);
                    }
                } else {
                    this.finishPaymentProcessingState();
                }
            })
            .catch(error => {
                this.finishPaymentProcessingState();
            });

    }

    handlePaymentRequestButtonClick(event) {
        event.preventDefault();

        this.startPaymentProcessingState();

        const { createPaymentClientSecret, cart } = this.props;

        createPaymentClientSecret(cart)
            .then((result) => {

                this.finishPaymentProcessingState();

                const errorMessages = result.messages;

                if (!errorMessages || errorMessages.length == 0) {
                    this.state.paymentRequest.update({
                        country: 'US',
                        currency: 'usd',
                        total: { label: 'Total Amount', amount: result.totalPaid * 100 },
                    });

                    this.state.paymentRequest.show();
                }
            })
            .catch(error => {
                this.finishPaymentProcessingState();
            });


    }

    render() {
        const createOptions = (fontSize, padding) => {
            return {
                style: {
                    base: {
                        fontSize,
                        color: '#424770',
                        letterSpacing: '0.025em',
                        fontFamily: 'Source Code Pro, monospace',
                        '::placeholder': {
                            color: '#aab7c4',
                        },
                        padding,
                    },
                    invalid: {
                        color: '#9e2146',
                    },
                },
            };
        };

        const { paymentRequest, canMakePayment, paymentProcessing, paymentError } = this.state;
        const { externalProcessing = processing, tournamentName, total, validationMessages, closePaymentDialogEmbeddedForm, showPaymentDialog } = this.props;

        const processing = externalProcessing || paymentProcessing;

        return (
            <StandardModal
                title="Payment"
                visible={showPaymentDialog}
                onCloseClick={closePaymentDialogEmbeddedForm}
                disableClose={processing}>
                <div>
                    <div className="row">
                        <div className="col-md-12 mb-3">
                            <div className="payment-info custom-card h-100" >
                                <div className="d-flex justify-content-center mb-1">
                                    <span className='fst-italic fw-bold text-center'>
                                        {tournamentName}
                                    </span>
                                </div>
                                <hr />
                                <h4 className="text-right">
                                    <strong>{`Total: $`}{total.formatCurrency(2)}</strong>
                                </h4>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <form onSubmit={this.handleFormSubmit} className='stripe-container'>
                                <div className="panel panel-default">
                                    <div className="panel-body">
                                        {canMakePayment === true &&
                                            <div>
                                                <PaymentRequestButtonElement
                                                    className={"PaymentRequestButton " + (processing ? 'div-disabled' : '')}
                                                    paymentRequest={paymentRequest}
                                                    onClick={this.handlePaymentRequestButtonClick} />

                                                <div className="Divider">
                                                    <hr />
                                                    <p className="Divider-Text Text Text-color--gray400 Text-fontSize--14 Text-fontWeight--400">
                                                        <span className="DividerText">Or pay with card</span>
                                                    </p>
                                                </div>
                                            </div>
                                        }


                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className='stripe-label'>Card number</label>
                                                    <CardNumberElement
                                                        onChange={this.handleCardElementChange}
                                                        {...createOptions(this.props.fontSize)}
                                                    />
                                                    {(!!this.state.cardElements.cardNumber.error && this.state.cardElements.cardNumber.touched == true) && (
                                                        <div className="error-text">{this.state.cardElements.cardNumber.error}</div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className='stripe-label'>Expiration date</label>
                                                    <CardExpiryElement
                                                        onChange={this.handleCardElementChange}
                                                        {...createOptions(this.props.fontSize)}
                                                    />
                                                    {(!!this.state.cardElements.cardExpiry.error && this.state.cardElements.cardExpiry.touched == true) && (
                                                        <div className="error-text">{this.state.cardElements.cardExpiry.error}</div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className='stripe-label'>CVC</label>
                                                    <CardCVCElement
                                                        onChange={this.handleCardElementChange}
                                                        {...createOptions(this.props.fontSize)}
                                                    />
                                                    {(!!this.state.cardElements.cardCvc.error && this.state.cardElements.cardCvc.touched == true) && (
                                                        <div className="error-text">{this.state.cardElements.cardCvc.error}</div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className='stripe-label'> Cardholder Name</label>
                                                    <input
                                                        id="billingName" name="billingName"
                                                        type="text"
                                                        placeholder="Full Name"
                                                        value={this.state.cardElements.cardholderName.value}
                                                        onChange={this.handleNameChange}
                                                        className="StripeElement InputElement"
                                                    />
                                                    {(!!this.state.cardElements.cardholderName.error && this.state.cardElements.cardholderName.touched == true) && (
                                                        <div className="error-text">{this.state.cardElements.cardholderName.error}</div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <DisplayIf condition={Array.isArray(validationMessages) && validationMessages.length > 0}>
                                            <div className="row">
                                                <div className="col-xs-12">
                                                    <div className="alert alert-danger text-center Text-fontSize--14 payment-alert">
                                                        <div>
                                                            {validationMessages ? validationMessages.map((message, index) => (
                                                                <div key={index}>
                                                                    {`${message}`}
                                                                </div>
                                                            )) : null}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </DisplayIf>
                                        <DisplayIf condition={!!paymentError}>
                                            <div className="row">
                                                <div className="col-xs-12">
                                                    <div className="alert alert-danger text-center Text-fontSize--14 payment-alert">
                                                        {paymentError}
                                                    </div>
                                                </div>
                                            </div>
                                        </DisplayIf>
                                    </div>
                                    <div className="panel-footer">
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <div className="display inline">
                                                    <button
                                                        className="btn btn-primary btn-lg"
                                                        disabled={processing}
                                                        type="submit"
                                                    >
                                                        <i className="fa fa-credit-card" /> {processing ? `Processing...` : `Pay`}
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-link"
                                                        disabled={processing}
                                                        onClick={() => closePaymentDialogEmbeddedForm()}
                                                    >{'Cancel'}</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </StandardModal>
        );
    }

    startPaymentProcessingState() {
        this.setState(prevState => ({
            ...prevState,
            paymentProcessing: true,
            paymentError: null,
        }));
    }

    finishPaymentProcessingState() {
        this.setState(prevState => ({
            ...prevState,
            paymentProcessing: false,
        }));
    }

    setPaymentError(errorMessage) {
        this.setState(prevState => ({
            ...prevState,
            paymentError: errorMessage,
        }));
    }
}

const mapStateToProps = (state) => ({
    ...state,
});

const mapDispatchToProps = {
    processPayment,
    createPaymentClientSecret,
    closePaymentDialogEmbeddedForm
};


export default connect(mapStateToProps, mapDispatchToProps)(injectStripe(PaymentForm));


// WEBPACK FOOTER //
// ./src/features/registration/checkout/EmbededForm/PaymentForm.jsx